import { Directive, ElementRef, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { ScrollSpyService, SpyItem } from './scroll-spy.service';

@Directive({ selector: '[mbScrollSpy]' })
export class ScrollSpyDirective implements SpyItem, OnInit, OnDestroy {
  private element = inject(ElementRef);
  private scrollSpyService = inject(ScrollSpyService);

  /**
   *  the id of the Scrollspy this is needed
   */
  @Input()
  public mbScrollSpy!: string;

  /**
   * the section of the scrollSpy
   */
  @Input()
  public spySection!: string;

  /**
   * the section of the scrollSpy
   */
  @Input()
  public dynamicSpySection!: boolean;

  /**
   * the order of the spyItems for each section
   */
  @Input()
  public order = 0;

  /**
   * label of the spyItem
   */
  public get label(): string {
    return this.mbScrollSpy;
  }

  /**
   * shows if the item is currently active
   */
  public active = false;

  /**
   * clientRect of the spyItem
   */
  get clientRect(): ClientRect {
    return (<HTMLElement>this.element.nativeElement).getBoundingClientRect();
  }

  ngOnInit() {
    if (this.mbScrollSpy) {
      if (this.dynamicSpySection) {
        this.scrollSpyService.addSpyDynamicItem(this);
      } else {
        this.scrollSpyService.addSpyItem(this);
      }
    }
  }

  ngOnDestroy() {
    this.scrollSpyService.removeSpyItem(this);
    this.scrollSpyService.removeSpyDynamicItem(this);
  }
}
